// api/MainApi.js
import axios from "axios";
import constants from "../config/consts.js";

class Api {
    constructor({ serverUrl }) {
        this._serverUrl = serverUrl;
        this._axios = axios.create({
            baseURL: serverUrl,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
    }

    // Аутентификация
    async adminSignIn(login, password) {
        const res = await this._axios.post('/admin_signin', { login, password });
        return res.data;
    }

    async adminSignOut() {
        const res = await this._axios.post('/admin_signout');
        return res.data;
    }

    async getAdminProfile() {
        const res = await this._axios.post('/get_admin');
        return res.data;
    }

    // Управление администраторами
    async getAdmins() {
        const res = await this._axios.post('/get_admins');
        return res.data;
    }

    async createAdmin(login, password, role, name) {
        const res = await this._axios.post('/create_admin', { login, password, role, name });
        return res.data;
    }

    async deleteAdmin(id) {
        const res = await this._axios.delete(`/delete_admin/${id}`);
        return res.data;
    }

    // Управление товарами
    async getProducts(status = '') {
        const url = status ? `/products_admin?status=${status}` : '/products_admin';
        const res = await this._axios.get(url);
        return res.data;
    }

    async getProductById(id) {
        const res = await this._axios.get(`/products_admin/${id}`);
        return res.data;
    }

    async createProduct(formData) {
        const res = await this._axios.post('/create_product', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return res.data;
    }

    async editProduct(id, formData) {
        const res = await this._axios.put(`/edit_product/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return res.data;
    }

    async deleteProductImages(id, imagesToDelete) {
        const res = await this._axios.delete(`/delete_image/${id}/images`, {
            data: { imagesToDelete }
        });
        return res.data;
    }

    async updateProductStatus(id, status) {
        const res = await this._axios.patch(`/change_status/${id}/status`, { status });
        return res.data;
    }

    async deleteProduct(id) {
        const res = await this._axios.delete(`/delete_product/${id}`);
        return res.data;
    }

    // === ЗАКАЗЫ ===
    async getOrders(status = '', limit = 100) {
        const params = {};
        if (status) params.status = status;
        if (limit) params.limit = limit;
        const res = await this._axios.get('/orders', { params });
        return res.data;
    }

    async getOrderById(id) {
        const res = await this._axios.get(`/order/${id}`);
        return res.data;
    }

    async createOrder(orderData) {
        const res = await this._axios.post('/create_order', orderData);
        return res.data;
    }

    async updateOrder(id, orderData) {
        const res = await this._axios.put(`/edit_order/${id}`, orderData);
        return res.data;
    }

    async updateOrderStatus(id, status, trackingNumber) {
        const res = await this._axios.patch(`/status_order/${id}`, { status, trackingNumber });
        return res.data;
    }

    async deleteOrder(id) {
        const res = await this._axios.delete(`/delete_order/${id}`);
        return res.data;
    }

    async findOrCreateUser(userData) {
        // предполагаемый эндпоинт: POST /users/find_or_create
        const res = await this._axios.post('/users/find_or_create', userData);
        return res.data; // ожидаем { userId: '...' }
    }

    async getUserById(id) {
        const res = await this._axios.get(`/users/${id}`);
        return res.data; // ожидаем { data: { ...user } }
    }
}

const API = new Api({
    serverUrl: constants.serverUrl
});

export default API;